<!--
 * @author xuyiyuan
 * @date 2023-08-17 13:52
 * @description  仓库管理
-->
<template>
  <lsTableLayout>
    <div slot="search">
      <lsSearchForm @search="onSearch" :formList="formList">
        <a-select slot="type" v-decorator="['type']" allowClear>
          <a-select-option v-for="(item) in WAREHOUSE_TYPE_LIST" :key="item.key">{{ item.value }}</a-select-option>
        </a-select>
        <a-select slot="status" v-decorator="['status']" allowClear>
          <a-select-option v-for="(item) in STATUS_LIST" :key="item.key">{{ item.name }}</a-select-option>
        </a-select>
      </lsSearchForm>
    </div>
    <div slot="table" class="table-container">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :multi-select="true"
        rowKey="id"
        :scroll="{ fixScreen: true, x: 1300 }"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.WAREHOUSE_LIST, // 表格方案配置唯一值
              }"
      >
        <template #type="{text}">
          <span>{{ WAREHOUSE_TYPE[text] }}</span>
        </template>
        <template slot="status" slot-scope="{ text }">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </template>
        <template #dataModifyTime="{text}">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template #dataCreateTime="{text}">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <!-- workShopDesc -->
        <template #workShopDesc="{ record }">
          <span v-if="!isEdit || currentId !== record.id">{{ record.workShopDesc }}</span>
          <a-select v-if="isEdit && currentId === record.id" v-model="record.workShopId" size="small">
            <a-select-option v-for="(item) in workShopDescList" :key="item.realValue">{{ item.label }}</a-select-option>
          </a-select>
        </template>
        <!-- 操作 -->
        <template #operation="{ record }">
          <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)">编辑</a>
          <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
        </template>
      </ls-api-table>
    </div>
  </lsTableLayout>
</template>

<script>
import { STATUS, STATUS_LIST, WAREHOUSE_TYPE, WAREHOUSE_TYPE_LIST } from './enum'
import {
  apiTSysInventoryOrganizationWarehouseList,
  apiWorkShopDescList,
  apiWorkShopDescUpdate
} from '@/api/mdm/supplychain/warehouse'
import { generateLsTableResData } from '@/utils/util.js';

const statusMap = {
  2: {
    status: 'processing',
    text: '未启用'
  },
  1: {
    status: 'processing',
    text: '启用'
  },
  0: {
    status: 'default',
    text: '停用'
  }
}

export default {
  name: 'Warehouse',
  components: {},
  data () {
    return {
      isEdit: false,
      currentId: "",
      STATUS,
      STATUS_LIST,
      WAREHOUSE_TYPE,
      WAREHOUSE_TYPE_LIST,
      formList: [
        {
          label: '仓库编码',
          decorator: ['warehouseCode'],
          type: 'input'
        },
        {
          label: '仓库名称',
          decorator: ['warehouseName'],
          type: 'input'
        },
        {
          label: '类型',
          type: 'type'
        },
        {
          label: '状态',
          type: 'status'
        }
      ],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiTSysInventoryOrganizationWarehouseList, true),
        pageCurrent: true
      },
      // 表头
      columns: [
        {
          title: '仓库编码',
          dataIndex: 'warehouseCode',
          width: 100
        },
        {
          title: '仓库名称',
          dataIndex: 'warehouseName',
          width: 160,
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'type',
          scopedSlots: { customRender: "type" },
          width: 100
        },
        {
          title: '所属库存组织',
          dataIndex: 'organizationName',
          width: 200,
          ellipsis: true
        },
        {
          title: '所属车间',
          dataIndex: 'workShopDesc',
          scopedSlots: { customRender: 'workShopDesc' },
          ellipsis: true,
          width: 200
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          width: 200,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: "status" },
          width: 100
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: "dataModifyTime" },
          width: 150
        },
        {
          title: '更新人',
          dataIndex: 'dataModifyUserName',
          width: 80
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: "dataCreateTime" },
          width: 150
        },
        {
          title: '创建人',
          dataIndex: 'dataCreateUserName',
          width: 80
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      workShopDescList: []
    }
  },
  mounted () {
    this.onSearch();
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    // 编辑
    handleEdit (record) {
      apiWorkShopDescList({
        organizationCode: record.organizationNo
      }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.workShopDescList = res.data
        }
      })
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.workShopId) {
        this.$message.warning('所属车间不能为空！')
        return
      }
      apiWorkShopDescUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          const params = this.$refs.dataTable.searchParams;
          this.onSearch(params);
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch();
    },
    // 表单搜索
    onSearch (values = {}) {
      this.isEdit = false
      const params = { ...values };
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.table-container {
  /deep/.ant-select{
    width: 140px;
  }
}
</style>
